/* eslint-disable @typescript-eslint/no-explicit-any */
export default function resetTouchFormikFields(
    formik: any,
    fields: string[],
): void {
    fields.forEach((field) => {
        formik.setFieldTouched(field, false, false)
    })
}
